module.exports = __webpack_public_path__ + "media/images/themes/mcdonalds_culture_service/form_component_sprite_small-0e643a48b7e9f1783d9045e64a255227.png";